import Http from '../http'

export default {

  index() {
    return Http.get(`/departments`)
  },

  indexByModel({model, model_id}) {
    return Http.get(`${model}/${model_id}/departments`)
  },

  create(department){
    return Http.post(`/departments`, {
      department: {
      ...department,
      }
    })
  },

  update(department){
    return Http.put(`/departments/${department.id}`, {
      department: {
        ...department,
      },
    });
  },

  show(id) {
    return Http.get(`/departments/${id}`);
  },

  delete(id){
    return Http.delete(`/departments/${id}`)
  }

}
